export const DEFAULT_INPUT_DELAY = 300;
export const NOTIFICATION_TIMEOUT = 5000;
